import React, { useState } from 'react';
import { getForgotPasswordLink } from '../../utils/getLinks';

export const LoginForm = ({ user, actions, loading, config }) => {
    const initialState = {
        email: '',
        password: '',
        terms_check: '',
    };

    const [state, setState] = useState(initialState);

    const handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        setState({
            ...state,
            [name]: value,
        });
    };

    const handleLogin = (event) => {
        event.preventDefault();

        actions.userActions.login(state);
    };

    const error = (loginIsError, loginError) => {
        if (loginIsError) {
            var errors = loginError.split(/<br\/>/g).filter((item) => {
                return item.length > 0;
            });
            return (
                <div className='alert alert-danger text-center' role='alert'>
                    {errors.map((err) => {
                        return <div key={err}>{err}</div>;
                    })}
                </div>
            );
        }
    };

    return (
        <div className='form-container login-form'>
            <div id='errors' className='errors'>
                {error(user.loginIsError, user.loginError)}
            </div>
            <form name='player_login' id='player_login' method='post' encType='application/x-www-form-urlencoded' onSubmit={handleLogin}>
                <input type='hidden' id='form_submitted' name='form_submitted' value='1' />

                <div className='form-group'>
                    <label htmlFor='email'>Email Address:</label>
                    <input
                        type='text'
                        id='email'
                        name='email'
                        size='32'
                        maxLength='60'
                        required={true}
                        onChange={handleChange}
                        placeholder='Enter Email'
                        className='form-control'
                    />
                </div>

                <div className='form-group'>
                    <label htmlFor='password'>Password:</label>
                    <input
                        type={state.page_show_pw ? 'text' : 'password'}
                        id='password'
                        name='password'
                        size='32'
                        maxLength='32'
                        required={true}
                        onChange={handleChange}
                        placeholder='Enter Password'
                        className='form-control'
                    />
                </div>

                <p className='pw-links'>
                    <a className='forgot' href={getForgotPasswordLink(config)} target='_blank' rel='noopener noreferrer'>
                        Forgot password?
                    </a>
                </p>

                <div className='d-flex justify-content-center'>
                    <button type='submit' name='submit' id='login-submit' className='theme-btn theme-btn-secondary theme-btn-lg text-uppercase px-5'>
                        {loading.actions['login'] && <span className='loading-icon ellipses' role='status' aria-hidden='true'></span>}
                        Log In
                    </button>
                </div>
            </form>
        </div>
    );
};

export default LoginForm;
